module.exports = __webpack_public_path__ + "d4447aa3.svg";